module.exports = __webpack_public_path__ + "img/SentimentNeutralOutlined.7390cad0.svg";